<template>
  <div class="chat-list-room" :id="`global-chat-list-room-${room.id}`" tabindex="0" :aria-label="'Chat Room: ' + displayName" v-bind:class="{waypoint: waypoint}" v-if="receiverEventAttendeeAllowsDirectMessages || isChatRoom">
    <span v-waypoint="{ active: true, callback: wayPointPassed }" v-if="waypoint"></span>
    <span v-waypoint="{ active: true, callback: wayPointPassed }" v-if="globalDirectWaypoint"></span>
    <div class="chat-list-room__content_left">
      <div class="chat-list-room__name" v-bind:class="{'new-message': hasUnreadMessage}">
        <global-chat-avatar-bubble
          v-bind:first-name="receiverEventAttendeeFirstName"
          v-bind:last-name="receiverEventAttendeeLastName"
          v-bind:avatar="receiverEventAttendeeAvatar"
          v-bind:can-moderate="false"
          v-bind:show-status="false"
          v-bind:chat-room="isChatRoom"
        >
        </global-chat-avatar-bubble>
        <span class='room-name'>
          {{displayName}} 
        </span>
        <span v-if="isBlocked" class='blocked-text-span'>{{lang.get('event_strings.global-chat.blocked_label')}}</span>
      </div>
    </div>  
    <div class="chat-list-room__content_right">
      <div class="chat-list-room__lasst-message-time" tabindex="0" :title="displayName" :aria-label="'Enter Chat Room: ' + displayName" role="button" @keydown.enter="handleKeydownPress()">
        <i @keydown.enter="handleKeydownPress()" class="far fa-chevron-right ml-2">
        </i>
      </div>
    </div>
    <div v-if="debug" v-on:click="handleDeleteClick()" class='delete-connection'>
      delete
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {

  props: ['room', 'messages', 'waypoint', 'currentEventAttendee', 'has-unread-message', 'debug', 'globalDirectWaypoint'],

  computed: {

    displayName () {
      return this.room.type == 'direct_message'
        ? this.receiverEventAttendeeName 
        : this.room.name
    },

    isBlocked () {
      if (!this.receiverEventAttendeeName) return false;
      return this.receiverEventAttendee.blocked_by_connections && this.receiverEventAttendee.blocked_by_connections.length
    },

    isChatRoom () {
      return !this.receiverEventAttendee
    },

    receiverEventAttendee () {
      // return this.room.event_attendees && this.room.event_attendees.find((ea) => ea.id !== this.currentEventAttendee.id)
      var globalChatConnection = this.room.global_chat_connection
      if (!globalChatConnection) return null
      return globalChatConnection.other_event_attendee
    },

    hasAttendeeFields () {
      return this.receiverEventAttendee && this.receiverEventAttendee.attendee_fields
    },

    receiverEventAttendeeFirstName () {
      if (!this.hasAttendeeFields) return ''
      return this.receiverEventAttendee.attendee_fields.first_name && `${this.receiverEventAttendee.attendee_fields.first_name}`
    },

    receiverEventAttendeeLastName () {
      if (!this.hasAttendeeFields) return ''
      return `${this.receiverEventAttendee.attendee_fields.last_name}`
    },

    receiverEventAttendeeName () {
      return this.hasAttendeeFields &&
        `${this.receiverEventAttendee.attendee_fields.first_name} ${this.receiverEventAttendee.attendee_fields.last_name}`
    },

    receiverEventAttendeeAvatar () {
      return this.receiverEventAttendee ? this.receiverEventAttendee.attendee_fields.user_avatar_url_medium : ''
    },

    receiverEventAttendeeAllowsDirectMessages () {
      if (!this.hasAttendeeFields) return ''
      return this.receiverEventAttendee.attendee_fields.allow_direct_messages
    },

    lastMessage () {
      if (!this.messages.length) return {}
      return this.messages[this.messages.length -1]
    },

    formattedLastMessageTime () {
      var createdAt = this.lastMessage && this.lastMessage.created_at
      if (!createdAt) return "";
      var createdAtString = ""
      try {
        createdAtString = `${createdAt.split(" ").join("T")}Z`
      } catch (e) {
        console.log(e)
      }
      if (!createdAtString) return ""
      return new moment(createdAtString).format('hh:mm A')
    }
  },

  methods: {
    wayPointPassed: function (e) {
      if (e.direction == 'top') {
        this.$root.$emit('get-more-chatrooms')
        this.$root.$emit('get-more-global-direct-chatrooms')
      }
    },

    handleDeleteClick: function () {
      this.$root.$emit('handle-delete-connection', this.room.global_chat_connection)
    },

    handleKeydownPress: function () {
      this.$root.$emit('open-chat', this.room)
      this.$nextTick(() => {
        $('.global-chat-text-input').trigger('focus')
      })
    }
  }

};
</script>

<style scoped>
  .chat-list-room__name .badge {
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 5px 10px;
    border-radius: 50%;
    height: 1rem;
    width: 1rem;
    background: red;
    color: white;
  }
</style>
